import { showLogTaskModal, showNewTaskModal, updateTask } from 'bundles/project/actions/index';

export const completeTask = task => updateTask({ ...task, completed: true });

export const newLeadActivity = lead => (
  (dispatch) => {
    dispatch(
      showLogTaskModal({
        defaultTaskAssociation: {
          associatedModelId: lead.contactId,
          associatedModelType: lead.contactType,
          default: true,
          name: lead.displayName
        }
      })
    );
  }
);

export const newLeadTask = lead => (
  (dispatch) => {
    dispatch(
      showNewTaskModal({
        defaultTaskAssociation: {
          associatedModelId: lead.contactId,
          associatedModelType: lead.contactType,
          default: true,
          name: lead.displayName
        }
      })
    );
  }
);
